var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReshotIconContactFormR3Zmvxk89S(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n\t.st1{fill:#FFEFE4;}\n\t.st2{fill:#69EBFC;}\n\t.st3{fill:#5FD4E3;}\n\t.st4{fill:#A1F1FC;}\n\t.st5{fill:#D476E2;}\n\t.st6{fill:#B665C2;}\n\t.st7{fill:#EA82FA;}\n\t.st8{fill:#FFF7F2;}\n\t.st9{fill:#FF8354;}\n\t.st10{fill:#FFA172;}\n\t.st11{fill:#6770E6;}\n\t.st12{fill:#5861C7;}\n\t.st13{fill:#E0734A;}\n\t.st14{fill:#EDD4C2;}\n\t.st15{fill:#CC6944;}\n\t.st16{fill:#858EFF;}\n\t.st17{fill:#C76642;}\n\t.st18{fill:#FFFFFF;}\n\t.st19{fill:#FFDEC7;}\n\t.st20{fill:#4E56B0;}\n\t.st21{fill:#94529E;}\n\t.st22{fill:#41B6C5;}\n\t.st23{fill:#9847A4;}\n\t.st24{fill:#C2552C;}\n\t.st25{fill:#CFB6A4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M229.935,256H26.065C11.67,256,0,244.33,0,229.935V26.065C0,11.67,11.67,0,26.065,0h203.87 C244.33,0,256,11.67,256,26.065v203.87C256,244.33,244.33,256,229.935,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M229.935,249H26.065C11.67,249,0,237.33,0,222.935v7C0,244.33,11.67,256,26.065,256h203.87 C244.33,256,256,244.33,256,229.935v-7C256,237.33,244.33,249,229.935,249z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M229.935,0H26.065C11.67,0,0,11.67,0,26.065V40h256V26.065C256,11.67,244.33,0,229.935,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M229.935,0H26.065C11.67,0,0,11.67,0,26.065v7C0,18.67,11.67,7,26.065,7h203.87C244.33,7,256,18.67,256,33.065 v-7C256,11.67,244.33,0,229.935,0z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 35,
    cy: 20,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 68.5,
    cy: 20,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 102,
    cy: 20,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M36.999,59.427h65.002c6.075,0,10.999,4.925,10.999,10.999v0c0,6.075-4.925,10.999-10.999,10.999H36.999 C30.925,81.425,26,76.501,26,70.426v0C26,64.351,30.925,59.427,36.999,59.427z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M133.999,59.427h65.002c6.075,0,10.999,4.925,10.999,10.999v0c0,6.075-4.925,10.999-10.999,10.999h-65.002 c-6.075,0-10.999-4.925-10.999-10.999v0C123,64.351,127.925,59.427,133.999,59.427z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M36.999,91.425h182.002c6.075,0,10.999,4.925,10.999,10.999v0c0,6.075-4.925,10.999-10.999,10.999H36.999 c-6.075,0-10.999-4.925-10.999-10.999v0C26,96.35,30.925,91.425,36.999,91.425z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M36.999,123.424h182.002c6.075,0,10.999,4.925,10.999,10.999v45c0,6.075-4.925,10.999-10.999,10.999H36.999 c-6.075,0-10.999-4.925-10.999-10.999v-45C26,128.348,30.925,123.424,36.999,123.424z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M215.599,107.239l-4.802-6.803c-0.335-0.474,0.004-1.128,0.585-1.128h9.604c0.58,0,0.919,0.654,0.585,1.128 l-4.802,6.803C216.483,107.643,215.884,107.643,215.599,107.239z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M35.143,225.571L35.143,225.571c-5.049,0-9.143-4.093-9.143-9.143v0c0-5.049,4.093-9.143,9.143-9.143h0 c5.049,0,9.143,4.093,9.143,9.143v0C44.286,221.478,40.192,225.571,35.143,225.571z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M35.143,221L35.143,221c-2.525,0-4.571-2.047-4.571-4.571l0,0c0-2.525,2.047-4.571,4.571-4.571h0 c2.525,0,4.571,2.047,4.571,4.571l0,0C39.714,218.953,37.668,221,35.143,221z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M111.714,220.143H58c-2.051,0-3.714-1.663-3.714-3.714l0,0c0-2.051,1.663-3.714,3.714-3.714h53.714 c2.051,0,3.714,1.663,3.714,3.714l0,0C115.429,218.48,113.766,220.143,111.714,220.143z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M96.357,142.704H42.643c-2.051,0-3.714-1.663-3.714-3.714l0,0c0-2.051,1.663-3.714,3.714-3.714h53.714 c2.051,0,3.714,1.663,3.714,3.714l0,0C100.071,141.041,98.408,142.704,96.357,142.704z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M76.357,74.14H42.643c-2.051,0-3.714-1.663-3.714-3.714v0c0-2.051,1.663-3.714,3.714-3.714h33.714 c2.051,0,3.714,1.663,3.714,3.714v0C80.071,72.477,78.408,74.14,76.357,74.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M106.357,106.139H42.643c-2.051,0-3.714-1.663-3.714-3.714v0c0-2.051,1.663-3.714,3.714-3.714h63.714 c2.051,0,3.714,1.663,3.714,3.714v0C110.071,104.476,108.408,106.139,106.357,106.139z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M181.375,73.723H137.66c-2.051,0-3.714-1.663-3.714-3.714v0c0-2.051,1.663-3.714,3.714-3.714h43.714 c2.051,0,3.714,1.663,3.714,3.714v0C185.089,72.061,183.426,73.723,181.375,73.723z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M126.357,156.923H42.643c-2.051,0-3.714-1.663-3.714-3.714l0,0c0-2.051,1.663-3.714,3.714-3.714h83.714 c2.051,0,3.714,1.663,3.714,3.714l0,0C130.071,155.26,128.408,156.923,126.357,156.923z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M149.714,225.571L149.714,225.571c-5.049,0-9.143-4.093-9.143-9.143v0c0-5.049,4.093-9.143,9.143-9.143h0 c5.049,0,9.143,4.093,9.143,9.143v0C158.857,221.478,154.764,225.571,149.714,225.571z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M226.286,220.143h-53.714c-2.051,0-3.714-1.663-3.714-3.714l0,0c0-2.051,1.663-3.714,3.714-3.714h53.714 c2.051,0,3.714,1.663,3.714,3.714l0,0C230,218.48,228.337,220.143,226.286,220.143z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReshotIconContactFormR3Zmvxk89S);
export default __webpack_public_path__ + "static/media/reshot-icon-contact-form-R3ZMVXK89S.dc2d68bee3234a035b3a4493a421e26f.svg";
export { ForwardRef as ReactComponent };